export const description =
  "Isolation, pompe à chaleur, poêle à granulés, VMC : toutes les opérations de rénovation résidentielle éligibles aux primes CEE et à MaPrimeRénov’ 2026. Aides cumulables.";
